export default __webpack_public_path__ + "static/media/95.e55610ee.gif";